// Builds the link to the Product / Stocking Locations (SKU × Site) detail page,
// carrying the persona context so the detail page opens scoped to the same
// scenario/run as the table the user clicked from.
// The persona a detail link must carry. Grouped rather than passed field by field: the detail
// page reads all of it from useActivePersonaContext, and its data query 404s if the experiment
// ids belong to a different scenario than the run. Two call sites already forgot fields once.
//
// experiment_id cannot travel in React context — it is deliberately not a SHARED_KEY, because
// PAGE_PERSONA scopes it per page — and LinkPreserveSearch cannot merge it in either: given a
// string `to` it replaces the search, which would drop sku and site.
export interface PersonaLinkContext {
  scenarioRunId?: string;
  runId?: string;
  refExperimentId?: string;
  experimentId?: string;
  periodFrom?: string;
  periodTo?: string;
}

const PERSONA_PARAM: Record<keyof PersonaLinkContext, string> = {
  scenarioRunId: 'scenario_run_id',
  runId: 'run_id',
  refExperimentId: 'ref_experiment_id',
  experimentId: 'experiment_id',
  periodFrom: 'period_from',
  periodTo: 'period_to',
};

// Builds the link to the Product / Stocking Locations (SKU × Site) detail page.
export function productStockingLocationHref(target: { sku: string; site: string }, persona: PersonaLinkContext = {}) {
  const qs = new URLSearchParams();
  qs.set('sku', target.sku);
  qs.set('site', target.site);
  for (const [field, param] of Object.entries(PERSONA_PARAM) as [keyof PersonaLinkContext, string][]) {
    const value = persona[field];
    if (value) qs.set(param, value);
  }
  return `/decisions/product-stocking-locations?${qs.toString()}`;
}
